// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"cb6537f0","239":"b3833d52","455":"2646d802","977":"f34b89b3"}[chunkId] + ".chunk.js";
};